export default __webpack_public_path__ + "static/media/Octicons.6b742a23.ttf";